import { cn } from '@/utils/ui'
import * as React from 'react'

const Input: React.FC<
  {
    ref?: React.Ref<HTMLInputElement>
    hasError?: boolean
  } & React.InputHTMLAttributes<HTMLInputElement>
> = ({ type, className, ref, hasError, ...props }) => {
  return (
    <input
      className={cn(
        `flex min-h-[35px] w-full rounded-md border mt-2 ${
          hasError ? `bg-bg-error border-border-error` : `border-border-input bg-background`
        } p-2 !text-body-XS-regular text-text-faded ring-offset-background placeholder:text-text-faded 
           focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2 
           disabled:cursor-not-allowed disabled:opacity-50`,
        className,
      )}
      ref={ref}
      type={type}
      {...props}
    />
  )
}

export { Input }
